import { render, staticRenderFns } from "./RegexValue.vue?vue&type=template&id=854beac4&scoped=true"
import script from "./RegexValue.vue?vue&type=script&lang=js"
export * from "./RegexValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "854beac4",
  null
  
)

export default component.exports